import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }

import { ref } from 'vue'
import { AppAuthService, UsersService } from '@prodcard/core'
import { AuthForm, PasswordResetForm, PasswordChangeForm } from '../features'
import { useRouter } from 'vue-router'
import { handleError } from '../helpers'

enum Step {
  AUTH,
  RESET,
  CHANGE,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthDialog',
  props: {
    authService: {},
    usersService: {},
    modelValue: { type: Boolean, default: false },
    prefilledEmail: {}
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }) {





const router = useRouter()
const email = ref('')
const currentStep = ref<Step>(Step.AUTH)

const toggle = (val: boolean) => {
  emit('update:model-value', val)
  setTimeout(() => {
    currentStep.value = Step.AUTH
    email.value = ''
  }, 200)
}

const redirect = () => {
  handleError(async () => {
    await router?.replace({ path: '/citizens' })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "500",
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": toggle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { width: "500" }, {
        default: _withCtx(() => [
          (currentStep.value === Step.AUTH)
            ? (_openBlock(), _createBlock(_unref(AuthForm), {
                key: 0,
                "auth-service": _ctx.authService,
                "user-email": _ctx.prefilledEmail,
                "onUpdate:email": _cache[2] || (_cache[2] = (str) => (email.value = str)),
                onLogin: _cache[3] || (_cache[3] = 
          () => {
            toggle(false)
            redirect()
          }
        )
              }, {
                links: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", {
                      class: "text-disabled text-decoration-underline text-body-2",
                      style: {"cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (currentStep.value = Step.RESET))
                    }, " Забыли пароль? "),
                    _createTextVNode("   "),
                    _createVNode(_component_router_link, {
                      class: "text-disabled text-decoration-underline text-body-2",
                      to: "/self-registration",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:model-value', false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Регистрация ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["auth-service", "user-email"]))
            : (currentStep.value === Step.RESET)
              ? (_openBlock(), _createBlock(_unref(PasswordResetForm), {
                  key: 1,
                  "pre-filled-email": email.value,
                  "auth-service": _ctx.authService,
                  onLogin: _cache[4] || (_cache[4] = ($event: any) => (currentStep.value = Step.CHANGE))
                }, null, 8, ["pre-filled-email", "auth-service"]))
              : (currentStep.value === Step.CHANGE)
                ? (_openBlock(), _createBlock(_unref(PasswordChangeForm), {
                    key: 2,
                    "auth-service": _ctx.authService,
                    "users-service": _ctx.usersService,
                    onChanged: _cache[5] || (_cache[5] = 
          () => {
            toggle(false)
            redirect()
          }
        )
                  }, null, 8, ["auth-service", "users-service"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})